const testimonialSlider = document.querySelectorAll(".homepage-testimonials .splide");

testimonialSlider.forEach((carousel) => {
	const splide = new Splide(carousel, {
		type: "loop",
		mediaQuery: "min",
		perPage: 1,
		perMove: 1,
		pagination: false,
		arrows: true,
		gap: "2em",
		padding: "0 30px",
		breakpoints: {
			980: {
				destroy: true,
			},
		},
	});

	splide.mount();
});
const testimonialCarousel = document.querySelectorAll(".testimonial-carousel.splide");

testimonialCarousel.forEach((carousel) => {
	const splide = new Splide(carousel, {
		type: "loop",
		mediaQuery: "min",
		perPage: 1,
		perMove: 1,
		pagination: false,
		arrows: true,
		gap: "2em",
		padding: "0 30px",
	});

	splide.mount();
});

const crossSellCarousel = document.querySelectorAll(".cross-sell-container .splide");

crossSellCarousel.forEach((carousel) => {
	const splide = new Splide(carousel, {
		type: "faded",
		mediaQuery: "min",
		perPage: 1,
		perMove: 1,
		arrows: true,
		gap: "0",
		breakpoints: {
			1200: {
				destroy: true,
			},
		},
	});

	splide.mount();
});
const similarArticlesCarousel = document.querySelectorAll(".similar-articles .splide, .similar-articles-block .splide");

similarArticlesCarousel.forEach((carousel) => {
	const splide = new Splide(carousel, {
		type: "faded",
		mediaQuery: "min",
		perPage: 1,
		focus: 'center',
		perMove: 1,
		arrows: false,
		gap: "0",
		breakpoints: {
			980: {
				// perPage: 2,
				// perMove: 2,
				gap: '2.4rem',
			},
			1200: {
				destroy: true,
			},
		},
	});

	splide.mount();
});

const comparisonChartCarousels = document.querySelectorAll(".mod-compare-chart");
if (comparisonChartCarousels) {
	comparisonChartCarousels.forEach((block, blockIndex) => {
		let mobileCarousel = block.querySelector(".mobile-content .chart-container.splide");
		if (mobileCarousel) {
			let mobileCompareCarousel = new Splide(mobileCarousel, {
				perPage: 1,
				mediaQuery: "max",
				perMove: 1,
				focus: 0,
				pagination: true,
				arrows: true,
				autoWidth: false,
				trimSpace: true,
				gap: "0",
				padding: "0",
				draggable: false,
				omitEnd: true,
				breakpoints: {
			980: {
				pagination: false
			},
		},
			});

			mobileCompareCarousel.mount();

			assignRowNumbers(mobileCarousel, "mobile", blockIndex);
			alignCompareChartRows(mobileCarousel, "mobile", blockIndex);
		}

		let desktopCarousel = block.querySelector(".desktop-content .chart-container.splide");
		if (desktopCarousel) {
			let desktopCompareCarousel = new Splide(desktopCarousel, {
				focus: 0,
				pagination: true,
				arrows: false,
				autoWidth: true,
				trimSpace: true,
				gap: "0",
				padding: "0",
				draggable: false,
				omitEnd: true,
			});

			desktopCompareCarousel.mount();

			let customPrevButton = block.querySelector(".js-splide-custom-prev");
			customPrevButton.addEventListener("click", function () {
				desktopCompareCarousel.go("<");
			});

			let customNextButton = block.querySelector(".js-splide-custom-next");
			customNextButton.addEventListener("click", function () {
				desktopCompareCarousel.go(">");
			});

			assignRowNumbers(desktopCarousel, "desktop", blockIndex);
			alignCompareChartRows(desktopCarousel, "desktop", blockIndex);
		}

		onresize = (event) => {
			const resizeCharts = document.querySelectorAll(".mod-compare-chart");
			resizeCharts.forEach((chart, chartIndex) => {
				const mobile = chart.querySelector(".mobile-content .chart-container.splide");
				const desktop = chart.querySelector(".desktop-content .chart-container.splide")
				alignCompareChartRows(mobile, "mobile", chartIndex);
				alignCompareChartRows(desktop, "desktop", chartIndex);
			})
			
		};
	});
}
function assignRowNumbers(chart, chartType, chartIndex) {
	const headers = chart.querySelectorAll(".headers li");
	const columns = chart.querySelectorAll(".chart-pad .item .column");

	headers.forEach((headerCell, headerIndex) => {
		headerCell.setAttribute("data-rownum", headerIndex);
		document.documentElement.style.setProperty(
			"--" + chartType + "-table-" + chartIndex + "-column-" + headerIndex + "-height",
			"auto"
		);
		headerCell.style.height =
			"var(--" + chartType + "-table-" + chartIndex + "-column-" + headerIndex + "-height)";
		columns.forEach((singleColumn) => {
			let columnRows = singleColumn.querySelectorAll("li");
			if (
				undefined !== columnRows[headerIndex] &&
				!columnRows[headerIndex].hasAttribute("data-rownum")
			) {
				columnRows[headerIndex].setAttribute("data-rownum", headerIndex);
				columnRows[headerIndex].style.height =
					"var(--" + chartType + "-table-" + chartIndex + "-column-" + headerIndex + "-height)";
			}
		});
	});
}

function alignCompareChartRows(chart, chartType, chartIndex) {
	const headers = chart.querySelectorAll(".headers li");

	headers.forEach((headerCell, headerIndex) => {
		document.documentElement.style.setProperty(
			"--" + chartType + "-table-" + chartIndex + "-column-" + headerIndex + "-height",
			"auto"
		);
		let rowCells = chart.querySelectorAll("li[data-rownum='" + headerIndex + "']");
		let maxHeight = 0;
		rowCells.forEach((cell) => {
			if (cell.offsetHeight > maxHeight) {
				maxHeight = cell.offsetHeight;
			}
		});
		document.documentElement.style.setProperty(
			"--" + chartType + "-table-" + chartIndex + "-column-" + headerIndex + "-height",
			maxHeight + "px"
		);
	});
}
